<template>
    <page-layout>
        <connect-network-failed :network="network" @go-back="$emit('go-to-source')" />

        <template #footer>
            <div style="text-align: center">
                <g-typography
                    v-if="route === 'v2.campaign.proposal.networks.failed'"
                    tag="p"
                    style="text-align: center"
                >
                    Need Help?
                    <router-link :to="{ name: 'v2.campaign.proposal.networks.faq' }">
                        <a>Read our FAQ's</a>
                    </router-link>
                </g-typography>

                <powered-by-grin />
            </div>
        </template>
    </page-layout>
</template>

<script>
    import { computed, onMounted } from 'vue-demi';
    import PageLayout from '../../layouts/PageLayout.vue';
    import ConnectNetworkFailed from './partials/ConnectNetworkFailed.vue';
    import useRouter from '../../../../src/composables/use-router';
    import useRoute from '../../../../src/composables/use-route';

    export default {
        name: 'ConnectNetworkFailedView',
        components: {
            PageLayout,
            ConnectNetworkFailed
        },
        setup() {
            const network = computed(() => useRoute().get().params.network);
            const route = computed(() => useRoute().get().name);

            onMounted(() => {
                if (!network.value) {
                    useRouter().get().go(-1);
                }
            });

            return { network, route };
        }
    };
</script>
